/**
 * /tenants/$slug/webhooks/$webhookId — detail route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchWebhook } from "@/features/webhooks/queries";
import { queryKeys } from "@/lib/query-keys";
import { WebhookDetailPage } from "@/features/webhooks/pages/webhook-detail-page";

export const Route = createFileRoute("/_authed/tenants/$slug/webhooks/$webhookId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.webhooks.detail(context.tenant.id, params.webhookId),
      queryFn: () => fetchWebhook(context.tenant.id, params.webhookId),
    }),
  component: WebhookDetailPage,
});
